import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const AreaChart = () => {
  const options = {
    chart: {
      type: "area",
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
      ],
    },
    yAxis: {
      title: {
        text: "Value",
      },
    },

    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "Dataset 1",
        data: [10, 20, 30, 40, 50, 60, 70, 80, 90],
        color: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
          stops: [
            [0, "#31A05F"], // Dark green at the top
            [1, "#FFFFFF"], // White at the bottom
          ],
        },
      },
    ],
  };

  return (
    <>
      <div className="chart-container">
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          style={{ width: "100%" }}
        />
        
      </div>
    </>
  );
};

export default AreaChart;
